import { render, staticRenderFns } from "./healthRecord.vue?vue&type=template&id=55a99e88&scoped=true&"
import script from "./healthRecord.vue?vue&type=script&lang=js&"
export * from "./healthRecord.vue?vue&type=script&lang=js&"
import style0 from "./healthRecord.vue?vue&type=style&index=0&id=55a99e88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a99e88",
  null
  
)

export default component.exports